export default __webpack_public_path__ + "static/media/az-logo-mobile.a7654925.svg";